export type SortBy = {
  value: string
  label: string
}

export type SortByIndex = {
  index: string
  values: SortBy[]
}

const generateCommonSortByValues = (index: string) => [
  { value: index, label: 'Relevancy' },
  { value: `${index}_orderby_date_desc`, label: 'Newest' },
  { value: `${index}_orderby_date_asc`, label: 'Oldest' },
]

const sortBy: SortByIndex[] = [
  {
    index: 'courses',
    values: generateCommonSortByValues('courses'),
  },
  {
    index: 'webinars',
    values: generateCommonSortByValues('webinars'),
  },
  {
    index: 'conferences',
    values: generateCommonSortByValues('conferences'),
  },
  {
    index: 'podcasts',
    values: generateCommonSortByValues('podcasts'),
  },
  {
    index: 'videos',
    values: generateCommonSortByValues('videos'),
  },
  {
    index: 'publications',
    values: generateCommonSortByValues('publications'),
  },
  {
    index: 'articles',
    values: generateCommonSortByValues('articles'),
  },
  {
    index: 'blogs',
    values: generateCommonSortByValues('blogs'),
  },
  {
    index: 'pages',
    values: generateCommonSortByValues('pages'),
  },
  {
    index: 'certification',
    values: generateCommonSortByValues('certification'),
  },
  {
    index: 'performance_resources',
    values: generateCommonSortByValues('performance_resources'),
  },
  //  {
  //   index: 'users',
  //   values: generateCommonSortByValues('pages'),
  // },
]

export default sortBy
